import { render, staticRenderFns } from "./PaymentRequisitesModal.vue?vue&type=template&id=4591c63c&lang=pug"
import script from "./PaymentRequisitesModal.vue?vue&type=script&lang=js"
export * from "./PaymentRequisitesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports